import Decimal from 'decimal.js';

import { RoommateData } from 'src/features/multi-occupancy/types';
import { LegalRepresentative, SelectedPrice } from 'src/shared/types/basket-types';

import { BasketProduct } from '../types';

export class BasketProductDto implements BasketProduct {
    readonly id: string;

    readonly room_code: string;

    readonly academic_year: string;

    readonly building_id: string;

    readonly development_id: string;

    readonly price: Decimal;

    readonly currency: string;

    readonly deposit: Decimal;

    readonly advance_payment_weeks: number;

    readonly deposit_prepaid: boolean;

    readonly selected_students: number;

    readonly term: string;

    readonly beds: number;

    readonly payment_plan_id: string;

    readonly instalment_type: string;

    readonly cbl: boolean;

    readonly stl: boolean;

    readonly occupants: RoommateData[];

    readonly selected_price: SelectedPrice;

    readonly legal_representative: LegalRepresentative | null;

    readonly promotion_id: string | null;

    constructor(rawBasketProduct: BasketProduct) {
        this.id = rawBasketProduct.id;
        this.room_code = rawBasketProduct.room_code;
        this.academic_year = rawBasketProduct.academic_year;
        this.building_id = rawBasketProduct.building_id;
        this.development_id = rawBasketProduct.development_id;
        this.price = rawBasketProduct.price;
        this.currency = rawBasketProduct.currency;
        this.deposit = rawBasketProduct.deposit;
        this.advance_payment_weeks = rawBasketProduct.advance_payment_weeks;
        this.deposit_prepaid = rawBasketProduct.deposit_prepaid;
        this.selected_students = rawBasketProduct.selected_students;
        this.term = rawBasketProduct.term;
        this.beds = rawBasketProduct.beds;
        this.payment_plan_id = rawBasketProduct.payment_plan_id;
        this.instalment_type = rawBasketProduct.instalment_type;
        this.cbl = rawBasketProduct.cbl;
        this.stl = rawBasketProduct.stl;
        this.occupants = rawBasketProduct.occupants;
        this.selected_price = rawBasketProduct.selected_price;
        this.legal_representative = rawBasketProduct.legal_representative;
        this.promotion_id = rawBasketProduct.promotion_id;
    }
}
